import React from 'react';

function CircularAIIcon({ size }) {
  const iconSize = size || '40px';

  return (
    <svg viewBox="-20 -20 140 140" xmlns="http://www.w3.org/2000/svg" width={iconSize} height={iconSize}>
      <defs>
        <linearGradient id="circularIconGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#A78BFA', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#FFFFFF', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <g>
        {/* Connecting Lines */}
        <g>
          <line x1="50" y1="50" x2="50" y2="5" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="3.5" />
          <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="8s" repeatCount="indefinite" />
        </g>
        <g>
          <line x1="50" y1="50" x2="10" y2="30" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="3.5" />
          <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="-360 50 50" dur="10s" repeatCount="indefinite" />
        </g>
        <g>
          <line x1="50" y1="50" x2="90" y2="70" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="3.5" />
          <animateTransform attributeName="transform" type="rotate" from="360 50 50" to="0 50 50" dur="6s" repeatCount="indefinite" />
        </g>
  
        {/* Central Node */}
        <circle cx="50" cy="50" r="24" fill="url(#circularIconGradient)" />
  
        {/* Orbiting Nodes (rendered on top of lines) */}
        <g>
          <circle cx="50" cy="5" r="15" fill="url(#circularIconGradient)" />
          <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="8s" repeatCount="indefinite" />
        </g>
        <g>
          <circle cx="10" cy="30" r="12" fill="url(#circularIconGradient)" />
          <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="-360 50 50" dur="10s" repeatCount="indefinite" />
        </g>
        <g>
          <circle cx="90" cy="70" r="13" fill="url(#circularIconGradient)" />
          <animateTransform attributeName="transform" type="rotate" from="360 50 50" to="0 50 50" dur="6s" repeatCount="indefinite" />
        </g>
      </g>
    </svg>
  );
}

export default CircularAIIcon; 